export default __webpack_public_path__ + "static/media/svg-2.5324c2f8.svg";